<template>
  <DialogContainer v-model="dialogObj">
    <template v-slot:dialogSlot>
      <div class="business-body custom-form">
          <div class="title-des">
            请根据订单实际情况进行核价，无需考虑发票价格
          </div>
          <el-row :gutter="20" class="input-price">
            <el-form ref="oldForm" :model="oldForm" :rules="rules" label-position="top">
              <el-col :span="24">
                <el-form-item prop="sourceFee">
                  <el-input
                    type="text"
                    @input="searchPrice"
                    placeholder="请输入价格"
                    v-model="oldForm.sourceFee"
                    maxlength="50"></el-input>
                </el-form-item>
              </el-col>
            </el-form>
          </el-row>
        <template
          v-loading="loading"
          element-loading-text="价格计算中..."
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.4)">
          <div class="title-box">
            客户需支付（含票）：
            <span class="price">{{ form.payableFee }}元</span>
          </div>
          <el-row class="price-des-box">
            <el-col :span="12" class="label-val">
              <span class="label">初始运单价格：</span>
              <span class="value">￥{{ form.sourceFee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">优惠/加价后价格：</span>
              <span class="value">￥{{ form.fee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">代理商运营费：</span>
              <span class="value">￥{{ form.agentFee }}</span>
            </el-col>
            <el-col :span="12" class="label-val">
              <span class="label">发票价格：</span>
              <span class="value">￥{{ form.invoiceFee }}</span>
            </el-col>
          </el-row>
        </template>
      </div>
    </template>
  </DialogContainer>
</template>

<script>
import DialogContainer from "@/components/Dialog.vue";
import {validatePrice} from "@/utils/validate";
import { feeConfirm } from "../api";
import {orderFreightPreFee} from '../../OrderQuery/api'
import {debounce} from "lodash";
export default {
  name: "AddOrEdit",
  components: {
    DialogContainer,
  },
  data() {
    return {
      cheImage: require("@/assets/imgs/title.png"),
      dialogObj: {
        loading: false,
        btnLoading: false,
        disabled: true,
        width: "500px",
        show: false,
        title: "运单价格调整",
        cancelTxt: "取消",
        confirmTxt: "提交价格",
        closeOnClickModal: false,
        confirmFn: this.submitForm,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.oldForm.sourceFee = "";
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {
        "agentFee": "",
        "fee": "",
        "invoiceFee": "",
        "payableFee": "",
        "sourceFee": "",
      },
      oldForm: {
        sourceFee: ''
      },
      orderId: "",
      rules: {
        sourceFee: [
          { required: true, message: "价格不能为空" },
          {validator: validatePrice, trigger: "blur"}
        ],
      },
      loading: false,
    };
  },
  mounted() {},
  methods: {
    init(row) {
      this.oldForm = Object.assign({}, row);
      this.orderId = row.orderId;
      this.dialogObj.show = true;
    },
    searchPrice: debounce(function (val) {
      if (!val) {
        this.form.agentFee = ''
        this.form.fee = ''
        this.form.invoiceFee = ''
        this.form.payableFee = ''
        this.form.sourceFee = ''
      }
      this.$refs.oldForm.validate((valid) => {
        if (valid) {
          this.loading = true
          this.oldForm.cargo.pictures = null
          // let obj = Object.assign({}, this.oldForm, {sourceFee: this.form.sourceFee});
          orderFreightPreFee( this.oldForm).then((res) => {
            if (res.code === 200) {
              this.form = Object.assign({}, res.data);
              this.dialogObj.disabled = false
            }
          }).finally((e) => {
            this.loading = false
          });
        }
      })
    }, 500),
    submitForm() {
      this.$confirm(`确定提交？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      }).then(() => {
        this.dialogObj.btnLoading = true;
        let params = {
          orderId: this.orderId, // 优惠/加价后价格
          pass: false,
          sourceFee: this.oldForm.sourceFee
        }
        feeConfirm(params).then((res) => {
          if (res.code === 200) {
            this.$message.success("价格审核成功")
            this.dialogObj.show = false;
            this.$emit("refreshData");
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .label-val {
    margin-bottom: 0.16rem;
    .label{
      width: 1.2rem;
      text-align: right;
    }
  }
  .title-box {
    padding: 0rem 0 0.2rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
    .price{
      font-size: 0.16rem;
      color: #0a65f0;
    }
  }
  .title-des{
    line-height: 1.3;
    color: rgba(0, 0, 0, 0.6);
  }
  .input-price{
    margin: 0.1rem 0;
  }
  .price-des-box{
    background-color: rgba(0,0,0,0.05);
    padding-top: 0.1rem;
    padding-left: 0.1rem;
    border-radius: 5px;
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .label-val{
    .label{
      color: #000000;
    }
    .value{
      color: #0a65f0;
      font-size: 0.14rem;
    }
  }
}
</style>
